<ng-container *ngIf="component.data$ | async as linkData">
  <cx-generic-link [url]="linkData.url">{{ linkData.label || linkData.name }}</cx-generic-link>
</ng-container>
